import { APIResponse } from '@/interfaces';
import { FileTypeEnum, PlatformEnum } from '../../enum';
import { baseSplitApi, FileUpload } from '@/services/api';

type BaseObject = {
  type: FileTypeEnum;
  data: FormData
};
export const fileApi = baseSplitApi.injectEndpoints({
  endpoints: builder => ({
    uploadFile: builder.mutation<APIResponse<FileUpload>, BaseObject>({
      query: ({formData, type, onUploadProgress}) => ({
        url: '/v1/file',
        method: 'POST',
        body: formData,
        params: {type},
        onProgress: (event: ProgressEvent) => {
          if (event.lengthComputable && onUploadProgress) {
            const progress = Math.round((event.loaded / event.total) * 100);
            onUploadProgress(progress);
          }
        },
        transformResponse: (response: {data: {url: string}}) =>
          response.data.url,
      }),
    }),
  }),
});
export const {useUploadFileMutation} = fileApi;
